import { render, staticRenderFns } from "./moons-modal.vue?vue&type=template&id=200289f3&"
import script from "./moons-modal.ts?vue&type=script&lang=ts&"
export * from "./moons-modal.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports